module.exports = __webpack_public_path__ + "static/img/merchant_feature_4.3cb28e8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/uupay/images/merchant_feature_4.png
// module id = lD+q
// module chunks = 8